import Vue from 'vue'
import axios from 'axios'
import VueLocalStorage from 'vue-localstorage'

Vue.use(VueLocalStorage);

const state = {
    categoriesWithSteps: [],
    categoryStatuses: []
};

const getters = {
    categoriesWithSteps(state) {
        return state.categoriesWithSteps;
    },
    categoryStatuses(state){
        return state.categoryStatuses
    }
};

const mutations = {
    SET_CATEGORIES_WITH_STEPS(state, newCategoriesWithSteps) {
        state.categoriesWithSteps = newCategoriesWithSteps;
    },
    SET_CATEGORY_STATUSES(state, newCategoryStatuses)
    {
        state.categoryStatuses = newCategoryStatuses;
    }
};

const actions = {
    loadCategoryWithSteps(context) {
        return new Promise((resolve, reject) => {
            axios.get("/api/categories/get-all-with-steps")
                .then(response => {
                    context.commit("SET_CATEGORIES_WITH_STEPS", response.data);
                    resolve(response);
                })
                .catch(error => {
                    reject(error);
                });
        });
    },
    loadCategoryStatuses(context) {
        return new Promise((resolve, reject) => {
            axios.get(`/api/categories/statuses/${context.getters.cgaPatientSheet.id}`)
                .then(response => {
                    context.commit("SET_CATEGORY_STATUSES", response.data);
                    resolve(response);
                })
                .catch(error => {
                    reject(error);
                });
        });
    }
    
};

export default {
    state,
    getters,
    mutations,
    actions
};